import angular from 'angular';

import ProfileImageDirective from './profile-image/profile-image.component';
import ProfileTagComponent from './profile-tag/profile-tag.component';
import ProfileImageUpload from './profile-image-upload/upload.component';

const DEPENDENCIES = [
  ProfileImageDirective,
  ProfileImageUpload,
  ProfileTagComponent,
];

export default angular.module('autoboard.profileImageComponent', DEPENDENCIES)
  .name;
